import * as apiPostSearch from 'api/ingredient/PostIngredientSearchV1';
import * as Ingredient from 'types/Ingredient/Search/Ingredient';

export type Type = Ingredient.Type[];

export function create(): Type {
	return [];
}

export function mapFromApi(obj: apiPostSearch.ResponseIngredient[]): Type {
	return [...obj];
}
